/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import React, { useEffect, useState, useContext, useCallback } from 'react';
import { useNavigate } from 'renative';

import {
  Container,
  ContentLogo,
  LogoIcon,
  LogoText,
  ContentWelcome,
  WelcomeTitle,
  WelcomeText,
  ContentAccess,
  PinInput,
  AccessButton,
  ContainerSideASide,
  ContentSideLogo,
  ContentSide,
  ContentMiddle,
  ContentKeyboard,
  KeyboardKey,
  KeyboardKeyText,
  AccessButtonText,
  LogoImage,
} from './styled';

import { ActivityIndicator } from 'react-native';
import { withFocusable } from '@noriginmedia/react-spatial-navigation';
import { hasWebFocusableUI } from '../../../config';
import { CURRENT_CONFIG } from '../../../config/branding';

// const FocusableView = hasWebFocusableUI ? withFocusable({})(View) : View;

import { pairWithCode } from '../../services/pairing';
import { CoreContext } from '../../context/CoreContext';
import { parseProfile } from '../../utils/parser';
import useRemoteControl from '../../hooks/useRemoteControl';

export default withFocusable({
  trackChildren: true,
  // forgetLastFocusedChild: false,
})(function Home(
  props: Record<string, unknown> & {
    setFocus: (key: string) => void;
    realFocusKey?: string;
    path?: string;
  },
) {
  const navigate = useNavigate(props);
  const [accessCode, setAccessCode] = useState<string[]>([]);

  const [cleaning, setCleaning] = useState(false);
  const [keyFocused, setKeyFocused] = useState<string | null>(null);

  const addKey = (item: number) => {
    if (accessCode?.length < 5) {
      setAccessCode([...accessCode, `${item}`]);
    }
  };

  const removeKey = () => {
    const keys = [...accessCode];
    keys.pop();
    setAccessCode([...keys]);
    setCleaning(true);
  };

  const handleRemote = useCallback((code: number) => {
    if (code === 10009 || code === 461 || code === 27 || code === 8 || code === 10182) {
      try {
        (
          window as unknown as Record<
            string,
            { application: { getCurrentApplication: () => { exit: () => void } } }
          >
        ).tizen.application
          .getCurrentApplication()
          .exit();
      } catch (er) {
        try {
          window.close();
        } catch (err) {
          console.log('cant');
          navigate('/');
        }
      }
    }
  }, []);

  const { pressed } = useRemoteControl(handleRemote);

  // const next = () => {
  //     console.log('Access with code :: ', accessCode.join('') )
  //     navigate('select-profile')
  // }

  useEffect(() => {
    console.log('Focus setting', props);
    props.setFocus('access-1');
    console.log('Focus setted');
  }, []);

  useEffect(() => {
    console.log('Handle focus setting', props.realFocusKey);
  }, [props.realFocusKey]);

  useEffect(() => {
    if (cleaning) {
      setCleaning(false);
    }
  }, [cleaning]);

  useEffect(() => {
    if (accessCode?.length >= 5) {
      props.setFocus('access-1');
    }
  }, [accessCode]);

  const { setProfiles, setCurrentProfile, setAuthentication, setUser } = useContext(CoreContext);
  const [loading, setLoading] = useState(false);

  const next = () => {
    console.log('Access with code :: ', accessCode.join(''));
    login();
  };

  const valid = (verbose = false) => {
    if (!accessCode || accessCode.length < 5) {
      if (verbose) {
        alert('Informe o código de acesso, você pode obte-lo acessando o aplicativo');
      }
      return false;
    }

    return true;
  };

  const login = async () => {
    if (!valid(true)) {
      return;
    }
    setLoading(true);
    const result = await pairWithCode(accessCode.join(''));
    setLoading(false);

    if (!result.ok) {
      if (result.reason === 'expired-token') {
        // Token inválido/expirado - limpar sessão
        setAuthentication(null);
      } else if (result.reason === 'network') {
        // Falha de conectividade (fetch lançou) — distinta de código inválido.
        // Reusa a copy de falha de conexão já usada em Catalog/Modal/useOnline.
        alert('Algo errado com a sua conexão de internet.');
      } else {
        alert('Código inválido');
      }
      setAccessCode([]);
      return;
    }

    // Persiste a sessão no CoreContext: o effect lê authentication.jwt -> setToken(),
    // sem o que os serviços autenticados continuariam sem token (Bug PR #152 finding 1).
    setAuthentication(result.authentication as Parameters<typeof setAuthentication>[0]);
    setUser(result.user as Record<string, unknown> | null);
    // Sempre resetar perfil/perfis para o estado resolvido — em re-login sem perfis
    // o estado antigo precisa ser limpo (não apenas sobrescrito quando truthy).
    setCurrentProfile(
      result.activeProfile
        ? (parseProfile(result.activeProfile as Record<string, unknown>) as Parameters<
            typeof setCurrentProfile
          >[0])
        : null,
    );
    setProfiles(
      result.profiles.map((p) => parseProfile(p as Record<string, unknown>)) as Parameters<
        typeof setProfiles
      >[0],
    );
    // Q1: navigate DIRECTLY to the resolved destination — no confirm-exit double-hop.
    navigate(result.destination);
  };

  return props.path !== '/' ? null : (
    <>
      <Container>
        <ContainerSideASide>
          <ContentSide>
            <ContentWelcome>
              <LogoImage />
              <WelcomeTitle aria-hidden="true" data-no-tts>
                Olá, bem-vindo(a)!
              </WelcomeTitle>
              <WelcomeText aria-hidden="true" data-no-tts>
                Para entrar no {CURRENT_CONFIG.displayName}, acesse o menu{' '}
                <WelcomeText bold>Perfil</WelcomeText> no aplicativo, depois aperte em{' '}
                <WelcomeText bold>Acesso a TV</WelcomeText> e digite o código gerado nos campos
                abaixo:
              </WelcomeText>
            </ContentWelcome>

            <ContentMiddle>
              <ContentAccess>
                {cleaning ? null : <PinInput onInputChange={setAccessCode} fields={accessCode} />}
              </ContentAccess>
            </ContentMiddle>

            <AccessButton
              active={accessCode?.length >= 5}
              onPress={next}
              onEnterPress={next}
              focusKey={'access-1'}
            >
              {loading ? (
                <ActivityIndicator color={'white'} />
              ) : (
                <AccessButtonText aria-hidden="true" data-no-tts>
                  Entrar
                </AccessButtonText>
              )}
            </AccessButton>

            <ContentKeyboard>
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 0].map((item, key) => (
                <KeyboardKey
                  key={key}
                  onPress={() => addKey(item)}
                  onEnterPress={() => addKey(item)}
                  focusKey={`home-${key + 1}`}
                >
                  <KeyboardKeyText>{item}</KeyboardKeyText>
                </KeyboardKey>
              ))}
              <KeyboardKey
                onPress={() => removeKey()}
                onEnterPress={() => removeKey()}
                focusKey={'remove-1'}
              >
                <KeyboardKeyText aria-hidden="true" data-no-tts>
                  Apagar
                </KeyboardKeyText>
              </KeyboardKey>
            </ContentKeyboard>
          </ContentSide>
        </ContainerSideASide>
      </Container>
    </>
  );
});
